import { TabMenu } from 'primereact/tabmenu';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import "./ConfBar.css";
import MenuItems from "./MenuItems";
import MenuItems2 from "./MenuItems2";
import MenuItems3 from "./MenuItems3";
import MenuItems4 from "./MenuItems4";
import MenuItems5 from "./MenuItems5";
import { Tooltip } from 'primereact/tooltip';
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ConfBar
Description : Tren de navegación módulo de novedades
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se implementa el tren de navegación desde cero.
2/11/2021 Cristian Andres Pizo Mina – Se modifico las direcciones de /Stactic y /Vacation.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

function ConfBar() {

    /*Propiedades del componente*/
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState("")
    const [dummy, setDummy] = useState("")
    const [items, setItems] = useState([]);
    var r = document.querySelector(':root');
    const items1 = MenuItems()
    const items2 = MenuItems2()
    const items3 = MenuItems3()
    const items4 = MenuItems4()
    const items5 = MenuItems5()
    let history = useHistory();

    useEffect(() => {

        setItems(items1)

        if (location.pathname.match(/Overtime/) || location.pathname.match(/Reported/) ||
            location.pathname.match(/Static/) || location.pathname.match(/Vacation/) ||
            location.pathname.match(/Licenses/)) {
            setItems(items1)
        }
        if (location.pathname.match(/PILASheets/) || location.pathname.match(/PILAHistoricSocialSecurity/)) {
            setItems(items2)
        }
        if (location.pathname.match(/Cost_center/) || location.pathname.match(/AccountantAccount_Plan/)
            || location.pathname.match(/AccountantThird/) || location.pathname.match(/AccountantAccountingConf/)) {
            setItems(items3)
        }
        if (location.pathname.match(/Users/) || location.pathname.match(/Password_management/)) {
            setItems(items4);
        }
        if (location.pathname.match(/PayrollPaymentProcess/) || location.pathname.match(/VacationProcess/) ||
            location.pathname.match(/AdditionalProcess/) || location.pathname.match(/Social_benefitsProcess/)) {
            setItems(items5);
        }
    }, [dummy])

    useEffect(() => {
        if (items.length > 0) {
            console.log(window.location.pathname)
            const route = items.filter((i) => window.location.pathname.includes(i.path))
            console.log(route)
            setActiveIndex(route[0].index)
        }
    }, [items])

    const handleTabClick = (event, path) => {
        // Allow right-click to show the default context menu
        if (event.type === "contextmenu") return;

        // Open in new tab if Ctrl+Click (Windows/Linux), Cmd+Click (Mac), or Middle Click
        if (event.ctrlKey || event.metaKey || event.button === 1) {
            window.open(path, "_blank");
        } else {
            event.preventDefault(); // Prevent default navigation
            history.replace(path);
            setActiveIndex(items.findIndex(item => item.path === path)); // Update active tab
        }
    };

    const tabItems = items.map(item => ({
        ...item,
        template: (options) => (
            <a
                href={item.path}
                onClick={(event) => handleTabClick(event, item.path)}
                onContextMenu={(event) => handleTabClick(event, item.path)}
                className={`${options.className} custom-tab`} // Keeps PrimeReact styles
                style={{ all: "unset", cursor: "pointer" }} // Reset <a> styles to avoid breaking UI
            >
                <div className="p-menuitem-link">
                    <span className={item.icon} style={{ marginRight: "8px" }}></span>
                    <span>{item.label}</span>
                </div>
            </a>
        )
    }));

    if (!(location.pathname.match(/Overtime/) || location.pathname.match(/Reported/) ||
        location.pathname.match(/Static/) || location.pathname.match(/Vacation/) ||
        location.pathname.match(/Licenses/) || location.pathname.match(/Cost_center/) ||
        location.pathname.match(/Account_Plan/) || location.pathname.match(/AccountantThird/) || location.pathname.match(/AccountantAccountingConf/) ||
        location.pathname.match(/Users/) || location.pathname.match(/Password_management/) ||
        location.pathname.match(/Certificate/) || location.pathname.match(/Voucher/) ||
        location.pathname.match(/PILAHistoricSocialSecurity/) || location.pathname.match(/PayrollPaymentProcess/) ||
        location.pathname.match(/VacationProcess/) || location.pathname.match(/AdditionalProcess/)
        || location.pathname.match(/Social_benefitsProcess/) || location.pathname.match(/PILASheets/))) {

        return null;
    }
    else {
        r.style.setProperty('--num-columns2', items.length);
        return (
            <div className="divbar surface-100	 inline-flex">
                <TabMenu className="confbar w-max align-items-center justify-content-center pl-3" model={tabItems} activeIndex={activeIndex} onTabChange={(e) => { setActiveIndex(e.index); setDummy(e.index) }} />
            </div>
        )
    }
}

export default ConfBar